/**
 * Act / Est for a column, from the name of the scenario it reads — all an engine column carries. The
 * response has no per-period adjustment flag, so an actuals scenario is `Act` throughout.
 */

import type { PnlAxisColumn } from 'src/components/star-grid/pnlAxis.types';

export const scenarioPeriodType = (scenario: string): NonNullable<PnlAxisColumn['periodType']> => (/actual/i.test(scenario) ? 'actual' : 'forecast');
